@if(areAllStockViewOptionsVisible){
@if(filtersService.onlyInStockFilter && filtersService.onlyInStockptions().length > 1){
<div class="dropdown" appDropdown>
  <button #dropdown class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown">
    {{getOptionLabel(filtersService.onlyInStockFilter)}}
  </button>
  <ul class="dropdown-menu">
    @for(opt of filtersService.onlyInStockptions(); let i = $index; track opt){
    <li [hidden]="withPezzotto && i === 1">
      <button class="dropdown-item" [disabled]="i === filtersService.getSelectedOptionIndex()"
        (click)="selectOption(opt)">
        {{getOptionLabel(opt)}}
      </button>
    </li>
    }
  </ul>
</div>
}
}
